import Add from './Add';
import Bars from './Bars';
import Bookings from './Bookings';
import Cancel from './Cancel';
import Check from './Check';
import Delete from './Delete';
import Remove from './Remove';
import Edit from './Edit';
import Favorites from './Favorites';
import List from './List';
import Save from './Save';
import Search from './Search';
import Replace from './Replace';
import Uber from './Uber';

export default { Add, Bars, Bookings, Cancel, Check, Delete, Remove, Edit, Favorites, List, Search, Save, Replace, Uber };
